import { ImmutableObject } from "@hookstate/core";
import { t } from "i18next";

import { Release } from "../../../types";
import { Flex, Text } from "@chakra-ui/react";
import { ShoppingPurchasedIcon } from "../../icons/ShoppingPurchasedIcon";

export function ReleasePurchaseData({
  release,
  alignItems = "start",
  pagesTextSuffix,
}: {
  release: ImmutableObject<Release>;
  alignItems?: "start" | "center";
  pagesTextSuffix?: string;
}) {
  const userOwnsRelease = !!release?.release_user_purchase;
  return (
    <Flex flexDirection="column" width="100%" alignItems={alignItems}>
      <Text variant="modalBody" fontSize="16px" color="neutral.400">
        {release.comic?.name}
      </Text>
      <Text variant="modalTitle" color="white" fontSize="18px" mt={1}>
        {release.title}
      </Text>
      <Text variant="modalBody" fontSize="14px" color="neutral.400" mt={1}>
        {release.page_count}{" "}
        {pagesTextSuffix ?? t("components.payments.pdf.pagesPDF")}
      </Text>
      {userOwnsRelease && (
        <Flex gap="8px" alignItems="center">
          <ShoppingPurchasedIcon boxSize="24px" color="blaze.blaze" />
          <Text
            fontWeight="500"
            fontSize="16px"
            lineHeight="130%"
            color="neutral.200"
          >
            {t("components.payments.purchaseRelease.youPurchasedThis")}
          </Text>
        </Flex>
      )}
    </Flex>
  );
}
